import type { CheckboxTreeNode } from './types.ts';
import { createContext } from 'react';

export interface CheckboxTreeContextType<TValue = never> {
  disabled?: boolean;
  onChange?: (selectedIds: Array<CheckboxTreeNode<TValue>['id']>) => void;
  renderLabel: (value: CheckboxTreeNode<TValue>['value']) => React.ReactNode;
  selectedIds: Array<CheckboxTreeNode<TValue>['id']>;
}

export const CheckboxTreeContext = createContext<CheckboxTreeContextType>(
  {} as CheckboxTreeContextType
);
